export default {
    AppEvents: {
        getFeedbackForm: {
            eventName: "GetFeedbackForm",
            parameters: {
                formId: "formId",
            },
        },
        endFeedback: {
            eventName: "FormResults",
            parameters: {
                formId: "formId",
                feedback: "formResults",
                endType: "endType",
            },
        },
        hypeOfferClicked:{
            eventName: "HypeOfferClicked",
            parameters: {
                offerId: "OfferId",
            },
        },
        launchOfferTypes: ["HypeOffer", "AssistTicketUpdate"],
    },
};


// WEBPACK FOOTER //
// ./settings/app-events.ts